import React from "react"
import { Link, graphql } from "gatsby"
import { rhythm } from "../utils/typography"
import Layout from "../components/layout"
import SEO from "../components/seo"
import {
  FaTwitter,
  FaGithub,
  FaMedium,
  FaDev,
  FaLinkedin,
  FaMailBulk
} from "react-icons/fa"
//https://medium.com/@vivekts90
const IndexData = ({ data, location }) => {
  const posts = data.allMarkdownRemark.edges
  const social = data.site.siteMetadata.social
  return (
    <Layout location={location} title={`Vivek T S`}>
      <SEO title="Vivek T S | Software Engineer" />
      <div
        style={{
          textAlign: `justify`,
          textJustify: `inter-word`,
          fontFamily: `Montserrat, sans-serif`,
        }}
      >
        <div style={{ marginBottom: 15, textAlign: `start` }}>
          <Link
            style={{ boxShadow: `none`, marginRight: `15px` }}
            to={`https://twitter.com/${social.twitter}`}
            target="_blank"
            rel="noreferrer"
          >
            <span>
              <FaTwitter
                size={25}
                color={"#1DA1F2"}
                style={{ boxShadow: `none` }}
              />
            </span>
          </Link>
          <Link
            style={{ boxShadow: `none`, marginRight: `15px` }}
            to={`https://github.com/${social.github}`}
            target="_blank"
            rel="noreferrer"
          >
            <span style={{ boxShadow: `none` }}>
              <FaGithub
                size={25}
                color={"#24292E"}
                style={{ boxShadow: `none` }}
              />
            </span>
          </Link>
          <Link
            style={{ boxShadow: `none`, marginRight: `15px` }}
            to={`https://medium.com/${social.medium}`}
            target="_blank"
            rel="noreferrer"
          >
            <span style={{ boxShadow: `none` }}>
              <FaMedium
                size={25}
                color={"#24292E"}
                style={{ boxShadow: `none` }}
              />
            </span>
          </Link>
          <Link
            style={{ boxShadow: `none`, marginRight: `15px` }}
            to={`https://dev.to/${social.dev}`}
            target="_blank"
            rel="noreferrer"
          >
            <span style={{ boxShadow: `none` }}>
              <FaDev
                size={25}
                color={"#24292E"}
                style={{ boxShadow: `none` }}
              />
            </span>
          </Link>
          <Link
            style={{ boxShadow: `none`, marginRight: `15px` }}
            to={`https://www.linkedin.com/in/${social.linkedin}`}
            target="_blank"
            rel="noreferrer"
          >
            <span style={{ boxShadow: `none` }}>
              <FaLinkedin
                size={25}
                color={"#0077B5"}
                style={{ boxShadow: `none` }}
              />
            </span>
          </Link>
          <Link
            style={{ boxShadow: `none` }}
            href={`mailto:${social.mail}`}
            target="_blank"
            rel="noreferrer"
          >
            <span style={{ boxShadow: `none` }}>
              <FaMailBulk
                size={25}
                style={{ boxShadow: `none` }}
              />
            </span>
          </Link>
        </div>

        <div style={{ textAlign: "start" }}>
          <ul style={{ listStyleType: `none`, marginLeft: 0 }}>
            <li style={{ display: `inline`, marginRight: 15 }}>
              <Link
                style={{
                  color: "#5F5F5F",
                  fontSize: "16px",
                  fontWeight: "bold",
                  fontFamily: `Montserrat, sans-serif`,
                }}
                to={`/about`}
              >
                About
              </Link>
            </li>
            <li style={{ display: `inline` }}>
              <Link
                style={{
                  color: "#5F5F5F",
                  fontSize: "16px",
                  fontWeight: "bold",
                  fontFamily: `Montserrat, sans-serif`,
                }}
                to={`/posts`}
              >
                Blog
              </Link>
            </li>
          </ul>
        </div>

        <div style={{ color: `#5F5F5F` }}>
          <p>I'm a Software Engineer.</p>
          <p>
            I’m currently employed at{" "}
            <a
              target="_blank"
              rel="noreferrer"
              style={{ boxShadow: `none`, color: `#000000` }}
              href="https://ust.com/en"
            >
              UST
            </a>{" "}
            working on the enterprise credit reporting product development for one of the largest consumer credit reporting agencies.
          </p>
          <p>
            I love building distributed systems and tackle the problems that
            come along using Java and its frameworks.
          </p>
          <p></p>
        </div>
      </div>
      <div>
        <h3
          style={{
            fontFamily: `Montserrat, sans-serif`,
            marginTop: 0,
            textAlign: `justify`,
            textJustify: `inter-word`,
            marginBottom: 15,
          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              color: `#1DA1F2`,
            }}
            to={`/posts`}
          >
            {`Recent Posts`}
          </Link>
        </h3>
        <div>
          <SEO title="Vivek T S | Software Engineer" />
          {posts.map(({ node }) => {
            const title = node.frontmatter.title || node.fields.slug
            return (
              <article key={node.fields.slug}>
                <header>
                  <p
                    style={{
                      marginBottom: rhythm(1 / 4),
                      fontFamily: `Montserrat, sans-serif`,
                      textAlign: `justify`,
                      textJustify: `inter-word`,
                    }}
                  >
                    <Link
                      style={{
                        color: "#5F5F5F",
                        fontSize: 15,
                      }}
                      to={node.fields.slug}
                    >
                      {title}
                    </Link>
                  </p>
                </header>
              </article>
            )
          })}
        </div>
      </div>
    </Layout>
  )
}

export default IndexData

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        author {
          name
          summary
        }
        social {
          twitter
          github
          medium
          dev
          linkedin
          mail
        }
      }
    }
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 3
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
          }
        }
      }
    }
  }
`
